import { useT } from '../i18n/useT';
import { cityViews as cvEn } from '../i18n/translations/en';
import { cityViews as cvEs } from '../i18n/translations/es';
import './CityViews.css';

const cityViewsImages = [
    { id: 1, image: "/assets/images/business-climate.jpeg", size: "large" },
    { id: 2, image: "/assets/images/opportunities.jpeg", size: "medium" },
    { id: 3, image: "/assets/images/continuous-growth.jpeg", size: "small" },
    { id: 4, image: "/assets/images/counties-growth.jpeg", size: "small" },
    { id: 5, image: "/assets/images/business-friendly.jpeg", size: "medium" },
    { id: 6, image: "/assets/images/venus-living.jpeg", size: "large" },
];

const CityViews = () => {
    const t = useT({ en: cvEn, es: cvEs });
    return (
        <section className="section city-views-section" id="why-venus">
            <div className="container">
                <div className="section-header text-center">
                    <h2 className="section-title">{t.title}<span>{t.titleSpan}</span></h2>
                    <p className="section-subtitle">{t.subtitle}</p>
                </div>
                <div className="views-gallery">
                    {cityViewsImages.map((view, i) => (
                        <div key={view.id} className={`view-item view-${view.size}`}>
                            <div className="view-image" style={{ backgroundImage: `url(${view.image})` }}></div>
                            <div className="view-overlay">
                                <div className="view-content">
                                    <h3 className="view-title">{t.items[i].title}</h3>
                                    <p className="view-description">{t.items[i].description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="text-center" style={{ marginTop: '3rem' }}>
                    <button className="btn btn-secondary" style={{ borderColor: 'var(--primary)', color: 'var(--primary)' }}>
                        {t.readStory}
                    </button>
                </div>
            </div>
        </section>
    );
};

export default CityViews;
